import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import SinglePromotionSection from "../../ui-kit/singlePromotionSection/singlePromotionSection";
import { getSinglePromo } from "../../store/promo/useCases/getSinglePromo/action";
import { IFilterRequest } from "../../store/products/repository/IFilterRequest";
import { saveCurrentSettings } from "../../store/products/repository/actions";

const SinglePromotionPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();

  const getParamsFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const filter: IFilterRequest[] = [];
    let priceMin: number | undefined;
    let priceMax: number | undefined;

    searchParams.forEach((value, key) => {
      if (key === 'priceMin') {
        priceMin = Number(value);
      } else if (key === 'priceMax') {
        priceMax = Number(value);
      } else if (!isNaN(Number(key))) {
        filter.push({
          keyId: Number(key),
          values: value.split(';')
        });
      }
    });

    return {
      id,
      ...(filter.length > 0 && { filter }),
      priceMin,
      priceMax,
    };
  };
  const settings = getParamsFromUrl();

  // useEffect(() => {
  //   if (settings) {
  //     dispatch(saveCurrentSettings({
  //       id: settings.id,
  //       filter: settings.filter,
  //       priceMin: settings.priceMin,
  //       priceMax: settings.priceMax
  //     }));
  //   }
  // }, [id, settings, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(getSinglePromo({
        id,
        isSavePrice: true,
        filter: settings?.filter,
        priceMin: settings?.priceMin,
        priceMax: settings?.priceMax,
      }));
    }
  }, [id, settings]);   

  return <SinglePromotionSection/>; 
};

export default SinglePromotionPage;